import type { DocNode } from '@atlaskit/adf-schema/doc';
import { filter } from '@atlaskit/adf-utils/filter';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

import type { FieldId } from '../../types/form/form-fields';
import type { FormSection } from '../../types/form/form-section';

export const getFieldIdsUnderSection = (section: FormSection): FieldId[] =>
	(section.layout.content ?? []).flatMap((contentNode) =>
		filter(contentNode, (node: ADFEntity) => {
			if (!node.attrs || !node.attrs.parameters) {
				return false;
			}

			const { id } = node.attrs.parameters;
			if (!((typeof id === 'string' && id.length > 0) || typeof id === 'number')) {
				return false;
			}

			return node.attrs.extensionKey === 'question';
		}).flatMap((node: ADFEntity) => (node.attrs ? [String(node.attrs.parameters.id)] : [])),
	);

/**
 * A section layout is "empty" when its doc has no content at all, e.g. when two section dividers
 * are placed directly next to each other in the form builder.
 *
 * `@atlaskit/renderer` fills an empty doc with an empty paragraph (a doc requires at least one
 * block), so rendering it produces an unintended blank line (JSDCLOUD-19698).
 *
 * A doc containing an empty paragraph is NOT empty: that is a blank line the form builder
 * deliberately added (by pressing Enter between sections) and must still be rendered.
 */
export const isSectionLayoutEmpty = (layout: DocNode | undefined): boolean =>
	(layout?.content?.length ?? 0) === 0;
